import { Platform } from "react-native";

type UseFormFieldAriaOptions = {
  hasLabel: boolean;
  labelId: string;
  errorId: string;
  errorText?: string;
};

export const useFormFieldAria = ({
  hasLabel,
  labelId,
  errorId,
  errorText,
}: UseFormFieldAriaOptions) => ({
  ...(hasLabel &&
    Platform.OS === "android" && {
      "aria-labelledby": labelId,
    }),
  "aria-invalid": Boolean(errorText) || undefined,
  ...(Platform.OS === "web" && errorText
    ? {
        "aria-describedby": errorId,
        "aria-errormessage": errorId,
      }
    : {}),
});
